import { getApiBearerToken, getIdToken } from "./auth/tokenService";

const credentials = "include";

const getAuthorizationHeader = () => {
  // Not necessarily the access token — under Entra this is the ID token. See
  // getApiBearerToken for why the access token cannot be used.
  const bearerToken = getApiBearerToken();
  const idToken = getIdToken();
  return {
    ...(bearerToken ? { Authorization: `Bearer ${bearerToken}` } : {}),
    // id_token carries additional claims (e.g. spin_id) not in the access_token
    ...(idToken ? { "X-Id-Token": idToken } : {}),
  };
};

const getGetOption = () => ({
  method: "GET",
  headers: {
    "accept-language": "en",
    ...getAuthorizationHeader(),
    "Content-Type": "application/json",
    Pragma: "no-cache",
  },
  credentials,
  cache: "no-cache",
});

const getGetNoLanguageOption = () => ({
  method: "GET",
  headers: {
    ...getAuthorizationHeader(),
    "Content-Type": "application/json",
    Pragma: "no-cache",
  },
  credentials,
  cache: "no-cache",
});

const getPutOption = () => ({
  method: "PUT",
  headers: {
    ...getAuthorizationHeader(),
    "Content-Type": "application/json",
  },
  credentials,
});

const getPostOption = () => ({
  method: "POST",
  headers: {
    "accept-language": "en",
    ...getAuthorizationHeader(),
    "Content-Type": "application/json",
  },
  credentials,
});

const getPostFileOption = () => ({
  method: "POST",
  headers: {
    "accept-language": "en",
    ...getAuthorizationHeader(),
  },
  credentials,
});

const getDeleteOption = () => ({
  method: "DELETE",
  headers: {
    ...getAuthorizationHeader(),
    "Content-Type": "application/json",
  },
  credentials,
});

const getPatchOption = () => ({
  method: "PATCH",
  headers: {
    ...getAuthorizationHeader(),
    "Content-Type": "application/json",
  },
  credentials,
});

export default {
  GET: getGetOption,
  GET_NO_LANGUAGE: getGetNoLanguageOption,
  PUT: getPutOption,
  POST: getPostOption,
  POSTFILE: getPostFileOption,
  DELETE: getDeleteOption,
  PATCH: getPatchOption,
};
